import React from 'react';
import { Typography, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Pipoheart from '../../files/icons/Pipoheart';

function CagnotteLink() {
  const { t } = useTranslation();

  return (
    <>
      <Typography
        component="h2"
        sx={{
          mb: 4,
          typography: {
            xs: 'h4',
            md: 'h3',
          },
          textAlign: 'center',
          color: 'terracota.main',
        }}
      >
        {t('cagnotte.online_title')}
      </Typography>

      <Button
        variant="outlined"
        href="https://www.onparticipe.fr/c/paulineetpierre"
        target="_blank"
        rel="noopener noreferrer"
        sx={{
          borderColor: 'terracota.main',
          borderWidth: 2,
          borderRadius: 2,
          mb: 6,
          px: 4,
          py: 1.5,
          fontSize: '1.1rem',
          textTransform: 'none',
          color: 'terracota.main',
          '&:hover': {
            borderWidth: 2,
            backgroundColor: 'terracota.light',
            color: 'terracota.dark',
          },
        }}
        startIcon={<Pipoheart size={24} color="#D85314" />}
      >
        {t('cagnotte.button')}
      </Button>
    </>
  );
}

export default CagnotteLink;
